const _excluded = ["checked", "disabled", "error", "defaultChecked", "indeterminate", "label", "onChange"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import Check from "@bolteu/kalep-react-icons/dist/Check";
import { cx } from "../../helpers/utils/cx";
import { mergeRefs } from "../../helpers/utils/mergeRefs";
const states = {
  valid: "border-neutral-primary peer-checked:bg-action-primary peer-indeterminate:bg-action-primary peer-hover:border-active-neutral-primary peer-checked:peer-hover:bg-active-action-primary peer-indeterminate:peer-hover:bg-active-action-primary",
  error: "border-danger-primary peer-checked:bg-danger-primary peer-indeterminate:bg-danger-primary peer-hover:border-active-danger-primary peer-checked:peer-hover:bg-active-danger-primary peer-indeterminate:peer-hover:bg-active-danger-primary"
};
const labelStates = {
  valid: "text-primary",
  error: "text-danger-primary"
};
export const Checkbox = /*#__PURE__*/React.forwardRef((props, forwardedRef) => {
  const internalRef = /*#__PURE__*/React.createRef();
  const {
      checked,
      disabled = false,
      error = false,
      defaultChecked,
      indeterminate = false,
      label,
      onChange
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  React.useEffect(() => {
    if (internalRef.current) {
      internalRef.current.indeterminate = indeterminate;
    }
  }, [indeterminate, internalRef]);
  const checkboxElement = /*#__PURE__*/React.createElement("span", {
    className: cx("shrink-0 w-6 h-6 p-px inline-grid grid-rows-1 grid-cols-1 place-items-center relative")
  }, /*#__PURE__*/React.createElement("input", _extends({
    type: "checkbox",
    checked: checked,
    defaultChecked: defaultChecked,
    disabled: disabled,
    onChange: onChange,
    ref: mergeRefs([internalRef, forwardedRef]),
    "aria-invalid": error
  }, rest, {
    className: cx("peer", ["w-full h-full m-0 appearance-none", disabled ? "cursor-not-allowed" : "cursor-pointer", "disabled:pointer-events-none"])
  })), /*#__PURE__*/React.createElement("span", {
    className: cx("absolute inset-px rounded-sm",
    // position absolutely 1px from each edge
    "transition-colors ease-linear duration-150",
    // animate color changes
    "pointer-events-none",
    // block pointer events from this visual element
    "border-solid border-2 border-neutral-primary bg-special-nulled text-static-key-light",
    // default unchecked
    "peer-checked:border-0",
    // checked
    "peer-indeterminate:border-0",
    // indeterminate
    "peer-disabled:peer-hover:bg-special-disabled",
    // disabled hover
    "peer-disabled:bg-special-disabled peer-disabled:text-tertiary peer-disabled:border-0",
    // disabled
    error ? states.error : states.valid)
  }), /*#__PURE__*/React.createElement(Check, {
    height: "22",
    width: "22",
    className: cx("absolute hidden peer-checked:inline row-start-1 text-static-key-light pointer-events-none", "peer-disabled:text-tertiary")
  }), /*#__PURE__*/React.createElement(Dash, {
    className: cx("absolute hidden peer-indeterminate:inline row-start-1 text-static-key-light pointer-events-none", "peer-disabled:text-tertiary")
  }));
  if (label) {
    return (
      /*#__PURE__*/
      // eslint-disable-next-line jsx-a11y/label-has-associated-control -- guaranteed to have control element
      React.createElement("label", {
        className: cx("bolt-font-body-m-regular inline-flex gap-2", disabled ? "cursor-not-allowed" : "cursor-pointer", error ? labelStates.error : labelStates.valid)
      }, checkboxElement, label)
    );
  }
  return checkboxElement;
});
function Dash(_ref) {
  let {
    className
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", {
    width: "12",
    height: "2",
    viewBox: "0 0 12 2",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.25 2H0.75C0.3 2 0 1.6 0 1C0 0.4 0.3 0 0.75 0H11.25C11.7 0 12 0.4 12 1C12 1.6 11.625 2 11.25 2Z",
    fill: "currentColor"
  }));
}